// const config = {
//   mode : "dev"
// }
const SERVER =
  // "https://api.onespring.co.kr/"
  document.domain.includes("pigro") || document.domain.includes("cloudfarm") // 실서비스
    ? "https://api.onespring.co.kr/"
    : "https://dev-api.onespring.co.kr/"; // 개발 서버

const ROOT_PATH = "api/v2020/";
const ROOT_PATH2 = "api/v2025/";
export const URLS = {
  user: {
    login: SERVER + ROOT_PATH + "user/login",
    logout: SERVER + ROOT_PATH + "user/logout",
    pageCount: SERVER + ROOT_PATH + "user/pageCount",
    findID: SERVER + ROOT_PATH + "user/findID",
    tempPassword: SERVER + ROOT_PATH + "user/tempPassword",
    changePassword: SERVER + ROOT_PATH + "user/changePassword",
    accountCheck: SERVER + ROOT_PATH + "user/accountCheck",
    insertUser: SERVER + ROOT_PATH + "user/insertUser",
    joinUser: SERVER + ROOT_PATH + "user/joinUser",
    searchCompanies: SERVER + ROOT_PATH + "user/searchCompanies",
    updateUser: SERVER + ROOT_PATH + "user/updateUser",
    updateUserFree: SERVER + ROOT_PATH + "user/updateUserFree",
    infoUser: SERVER + ROOT_PATH + "user/infoUser",
    getUserType: SERVER + ROOT_PATH + "user/getUserType",
    listUsers: SERVER + ROOT_PATH + "user/listUsers",
    insertUsersControl: SERVER + ROOT_PATH + "user/insertUsersControl",
    deleteUsersControl: SERVER + ROOT_PATH + "user/deleteUsersControl",
    treeManagermentCompanies:
      SERVER + ROOT_PATH + "user/treeManagermentCompanies",
    listAccesableServices: SERVER + ROOT_PATH + "user/listAccesableServices",
  },
  setup: {
    insertDealCompany: SERVER + ROOT_PATH + "setup/insertDealCompany",
    updateDealCompany: SERVER + ROOT_PATH + "setup/updateDealCompany",
    infoDealCompany: SERVER + ROOT_PATH + "setup/infoDealCompany",
    comboDealCompanies: SERVER + ROOT_PATH + "setup/comboDealCompanies",
    listDealCompanies: SERVER + ROOT_PATH + "setup/listDealCompanies",
  },
  farm: {
    insertCompany: SERVER + ROOT_PATH + "farm/insertCompany",
    updateCompany: SERVER + ROOT_PATH + "farm/updateCompany",
    updateCompanyFree: SERVER + ROOT_PATH + "farm/updateCompanyFree",
    infoCompany: SERVER + ROOT_PATH + "farm/infoCompany",
    comboCompanies: SERVER + ROOT_PATH + "farm/comboCompanies",
    listCompanies: SERVER + ROOT_PATH + "farm/listCompanies",
    insertFarm: SERVER + ROOT_PATH + "farm/insertFarm",
    updateFarm: SERVER + ROOT_PATH + "farm/updateFarm",
    updateFarmFree: SERVER + ROOT_PATH + "farm/updateFarmFree",
    infoFarm: SERVER + ROOT_PATH + "farm/infoFarm",
    comboFarms: SERVER + ROOT_PATH + "farm/comboFarms",
    listFarms: SERVER + ROOT_PATH + "farm/listFarms",
    listFarmsForMap: SERVER + ROOT_PATH + "farm/listFarmsForMap",
    updateBuildingFree: SERVER + ROOT_PATH + "farm/updateBuildingFree",
    insertBuildingOne: SERVER + ROOT_PATH + "farm/insertBuildingOne",
    infoBuilding: SERVER + ROOT_PATH + "farm/infoBuilding",
    comboBuildings: SERVER + ROOT_PATH + "farm/comboBuildings",
    listBuildings: SERVER + ROOT_PATH + "farm/listBuildings",
    insertRoom: SERVER + ROOT_PATH + "farm/insertRoom",
    updateRoom: SERVER + ROOT_PATH + "farm/updateRoom",
    infoRoom: SERVER + ROOT_PATH + "farm/infoRoom",
    comboRooms: SERVER + ROOT_PATH + "farm/comboRooms",
  },
  schedule: {
    listFarmEvent: SERVER + ROOT_PATH + "schedule/listFarmEvent",
  },
  device: {
    comboSensors: SERVER + ROOT_PATH + "device/comboSensors",
    getNowControllerValue: SERVER + ROOT_PATH + "device/getNowControllerValue",
    comboData_names: SERVER + ROOT_PATH + "device/comboData_names",
    comboSensorData: SERVER + ROOT_PATH + "device/comboSensorData",
    treeDeodorizerDviceMonitoring:
      SERVER + ROOT_PATH + "device/treeDeodorizerDviceMonitoring",
    updateDeodorizer: SERVER + ROOT_PATH + "device/updateDeodorizer",
  },
  control: {
    listMonitoringControllers:
      SERVER + ROOT_PATH + "control/listMonitoringControllers",
    infoDetailRoomControllers:
      SERVER + ROOT_PATH + "control/infoDetailRoomControllers",
    listSettingHistories: SERVER + ROOT_PATH + "control/listSettingHistories",
    infoSettingHistory: SERVER + ROOT_PATH + "control/infoSettingHistory",
    saveControllerSetting: SERVER + ROOT_PATH + "control/saveControllerSetting",
    stopRemoteControl: SERVER + ROOT_PATH + "control/stopRemoteControl",
    saveSeasonRange: SERVER + ROOT_PATH + "control/saveSeasonRange",
    deleteSeasonRange: SERVER + ROOT_PATH + "control/deleteSeasonRange",
    comboSeasonRanges: SERVER + ROOT_PATH + "control/comboSeasonRanges",
    listSeasonRanges: SERVER + ROOT_PATH + "control/listSeasonRanges",
    infoSeasonRange: SERVER + ROOT_PATH + "control/infoSeasonRange",
    saveWeightRange: SERVER + ROOT_PATH + "control/saveWeightRange",
    deleteWeightRange: SERVER + ROOT_PATH + "control/deleteWeightRange",
    comboWeightRanges: SERVER + ROOT_PATH + "control/comboWeightRanges",
    listWeightRanges: SERVER + ROOT_PATH + "control/listWeightRanges",
    infoWeightRange: SERVER + ROOT_PATH + "control/infoWeightRange",
    saveControlRangeSettings:
      SERVER + ROOT_PATH + "control/saveControlRangeSettings",
    deleteControlRangeSettings:
      SERVER + ROOT_PATH + "control/deleteControlRangeSettings",
    listControlRangeSettings:
      SERVER + ROOT_PATH + "control/listControlRangeSettings",
    saveFanControlPreset: SERVER + ROOT_PATH + "control/saveFanControlPreset",
    loadFanControlPreset: SERVER + ROOT_PATH + "control/loadFanControlPreset",
    comboFanControlPresets:
      SERVER + ROOT_PATH + "control/comboFanControlPresets",
    confirmFanControlPreset:
      SERVER + ROOT_PATH + "control/confirmFanControlPreset",

    comboDeodorizers: SERVER + ROOT_PATH + "control/comboDeodorizers",
    infoDeodorizerSetting: SERVER + ROOT_PATH + "control/infoDeodorizerSetting",
    listMonitorDeodorizers:
      SERVER + ROOT_PATH + "control/listMonitorDeodorizers",
    saveDeodorizerSetting: SERVER + ROOT_PATH + "control/saveDeodorizerSetting",
    setStatusOfDeodorizer: SERVER + ROOT_PATH + "control/setStatusOfDeodorizer",
    deodorizerOnLines: SERVER + ROOT_PATH + "control/deodorizerOnLines",
    deodorizerOnAllLines: SERVER + ROOT_PATH + "control/deodorizerOnAllLines",
    deodorizerOffAllLines: SERVER + ROOT_PATH + "control/deodorizerOffAllLines",
    deodorizerAutoAllLines:
      SERVER + ROOT_PATH + "control/deodorizerAutoAllLines",
    deodorizerOffLines: SERVER + ROOT_PATH + "control/deodorizerOffLines",
    deodorizerAutoLines: SERVER + ROOT_PATH + "control/deodorizerAutoLines",
    deodorizerManualLines: SERVER + ROOT_PATH + "control/deodorizerManualLines",
  },
  monitor: {
    monitoringSummary: SERVER + ROOT_PATH + "monitor/monitoringSummary",
    buildingSummaryView: SERVER + ROOT_PATH + "monitor/buildingSummaryView",
    farmSummaryViewForLite:
      SERVER + ROOT_PATH + "monitor/farmSummaryViewForLite",
    // farmSummaryView: SERVER + ROOT_PATH + "monitor/farmSummaryView",
    roomDailyViewServices: SERVER + ROOT_PATH + "monitor/roomDailyViewServices",
    roomDailyView: SERVER + ROOT_PATH + "monitor/roomDailyView",
    room24hoursView: SERVER + ROOT_PATH + "monitor/room24hoursView",
    roomRawDataView: SERVER + ROOT_PATH + "monitor/roomRawDataView",
    // monitoringSummary: SERVER + ROOT_PATH + "monitor/monitoringSummary",
    monitoringWeather: SERVER + ROOT_PATH + "monitor/monitoringWeather",
    summaryPigInfo: SERVER + ROOT_PATH + "monitor/summaryPigInfo",
    listFarmKepcoData: SERVER + ROOT_PATH + "monitor/listFarmKepcoData",
    kepcoDataDailyView: SERVER + ROOT_PATH + "monitor/kepcoDataDailyView",
    kepcoDataMonthlyView: SERVER + ROOT_PATH + "monitor/kepcoDataMonthlyView",
    listTimelyKepcoData: SERVER + ROOT_PATH + "monitor/listTimelyKepcoData",

    listTimelyKepcoDataEach:
      SERVER + ROOT_PATH + "monitor/listTimelyKepcoDataEach",
    kepcoDataDailyViewEach:
      SERVER + ROOT_PATH + "monitor/kepcoDataDailyViewEach",
    kepcoDataMonthlyViewEach:
      SERVER + ROOT_PATH + "monitor/kepcoDataMonthlyViewEach",

    weatherForDeodorizer: SERVER + ROOT_PATH + "monitor/weatherForDeodorizer",
    weatherForecast: SERVER + ROOT_PATH + "monitor/weatherForecast",
    weatherDataDailyView: SERVER + ROOT_PATH + "monitor/weatherDataDailyView",
  },
  esg: {
    comboEsgFarms: SERVER + ROOT_PATH + "esg/comboEsgFarms",
    comboKepcoFarms: SERVER + ROOT_PATH + "esg/comboKepcoFarms",
    estimateAmountForEnergyPerMonth:
      SERVER + ROOT_PATH + "esg/estimateAmountForEnergyPerMonth",
    listAmountForEnergyPerMonth:
      SERVER + ROOT_PATH + "esg/listAmountForEnergyPerMonth",
    monitoringEsgValueOfFarm:
      SERVER + ROOT_PATH + "esg/monitoringEsgValueOfFarm",
    monitoringEsgValueOfFarm2:
      SERVER + ROOT_PATH + "esg/monitoringEsgValueOfFarm2",

    // record
    listCountHeadOfFarmPerMonth:
      SERVER + ROOT_PATH + "esg/listCountHeadOfFarmPerMonth",
    listSlaughterHeadOfFarmPerDay:
      SERVER + ROOT_PATH + "esg/listSlaughterHeadOfFarmPerDay",
    listSlaughterHeadOfFarmPerMonth:
      SERVER + ROOT_PATH + "esg/listSlaughterHeadOfFarmPerMonth",
    infoMarketRealTime: SERVER + ROOT_PATH + "esg/infoMarketRealTime",
    listAmountHistoryPerDay: SERVER + ROOT_PATH + "esg/listAmountHistoryPerDay",
    listCattleGradeData: SERVER + ROOT_PATH + "esg/listCattleGradeData",
    getCattleTrace: SERVER + ROOT_PATH + "esg/getCattleTrace",

    accumulateWattPerDay: SERVER + ROOT_PATH + "esg/accumulateWattPerDay",
    accumulateWattLastYearMonth:
      SERVER + ROOT_PATH + "esg/accumulateWattLastYearMonth",

    certifyLowCarbonBase: SERVER + ROOT_PATH + "esg/certifyLowCarbonBase",
  },
  alert: {
    listAlertSetupOfFarm: SERVER + ROOT_PATH + "alert/listAlertSetupOfFarm",
    saveAlertSetupOfRoom: SERVER + ROOT_PATH + "alert/saveAlertSetupOfRoom",
    savePersonalChoicedAlerts:
      SERVER + ROOT_PATH + "alert/savePersonalChoicedAlerts",
    infoPersonalChoicedAlerts:
      SERVER + ROOT_PATH + "alert/infoPersonalChoicedAlerts",
    listAlertSetupOfFarm2025:
      SERVER + ROOT_PATH + "alert/listAlertSetupOfFarm2025",
    saveAlertSetup2025: SERVER + ROOT_PATH + "alert/saveAlertSetup2025",
    saveAlertVoiceSetup: SERVER + ROOT_PATH + "alert/saveAlertVoiceSetup",
    listAlertsOfFarm: SERVER + ROOT_PATH + "alert/listAlertsOfFarm",
  },
  package: {
    comboMilkingFarms: SERVER + ROOT_PATH + "package/comboMilkingFarms",
    statisticsOfDairyMilkPerEntity:
      SERVER + ROOT_PATH + "package/statisticsOfDairyMilkPerEntity",
    listDairyMilk: SERVER + ROOT_PATH + "package/listDairyMilk",
    statisticsOfDairySuckMilkPerEntity:
      SERVER + ROOT_PATH + "package/statisticsOfDairySuckMilkPerEntity",
    listDairySuckMilk: SERVER + ROOT_PATH + "package/listDairySuckMilk",
    statisticsOfDairyMilkMonthly:
      SERVER + ROOT_PATH + "package/statisticsOfDairyMilkMonthly",
    statisticsOfDairyMilkDaily:
      SERVER + ROOT_PATH + "package/statisticsOfDairyMilkDaily",
    listRawDataOfPackage: SERVER + ROOT_PATH2 + "package/listRawDataOfPackage",
    statisticsOfDiaryWaterTimely:
      SERVER + ROOT_PATH2 + "package/statisticsOfDiaryWaterTimely",
    statisticsOfDairyWaterDaily:
      SERVER + ROOT_PATH2 + "package/statisticsOfDairyWaterDaily",
    listBI01dataOfPackage:
      SERVER + ROOT_PATH2 + "package/listBI01dataOfPackage",
    listDiaryBI01dataOfEntity:
      SERVER + ROOT_PATH2 + "package/listDiaryBI01dataOfEntity",
    monitorEC08dataOfPackageInFarm:
      SERVER + ROOT_PATH2 + "package/monitorEC08dataOfPackageInFarm",
    monitorEC01dataOfPackageInFarm:
      SERVER + ROOT_PATH2 + "package/monitorEC01dataOfPackageInFarm",
    monitorEC05dataOfPackageInFarm:
      SERVER + ROOT_PATH2 + "package/monitorEC05dataOfPackageInFarm",
    listAF08dataOfPackage:
      SERVER + ROOT_PATH2 + "package/listAF08dataOfPackage",
    listAF01dataOfPackage:
      SERVER + ROOT_PATH2 + "package/listAF01dataOfPackage",
    listAF01DailyOfDevice:
      SERVER + ROOT_PATH2 + "package/listAF01DailyOfDevice",
  },
  cs: {
    insertAsHead: SERVER + ROOT_PATH2 + "cs/insertAsHead",
    updateAsHead: SERVER + ROOT_PATH2 + "cs/updateAsHead",
    listAsHeads: SERVER + ROOT_PATH2 + "cs/listAsHeads",
    infoAsProcess: SERVER + ROOT_PATH2 + "cs/infoAsProcess",
    insertNotice: SERVER + ROOT_PATH2 + "cs/insertNotice",
    updateNotice: SERVER + ROOT_PATH2 + "cs/updateNotice",
    listNotices: SERVER + ROOT_PATH2 + "cs/listNotices",
  },
  ai: {
    getDivisionsOfRoomsInFarm:
      SERVER + ROOT_PATH2 + "ai/getDivisionsOfRoomsInFarm",
    predictWatt: SERVER + ROOT_PATH2 + "ai/predictWatt",
  },
  system: {
    sendSMS: SERVER + ROOT_PATH + "system/sendSMS",
  },
  all: {
    baseCodeList: SERVER + ROOT_PATH + "all/baseCodeList",
  },
  test: {
    testParams: SERVER + ROOT_PATH + "test/testParams",
    goodLuck: SERVER + ROOT_PATH + "test/goodLuck",
  },
  combo: {
    // getComboList 테스트
    // getComboList: SERVER + ROOT_PATH + "combo/getComboList",
  },
  redis: {
    lastValue: SERVER + ROOT_PATH + "redis/lv",
  },
  mongo: {
    trend: SERVER + ROOT_PATH + "mongo/trend",
  },
};

export default URLS;
